import client from './oc2api';

export type FeaturedCompany = {
  id: number;
  company_name: string;
  square_logo: string | undefined;
  business_category_name: string;
  business_subcategory_name: string;
};

export type FeaturedCompaniesData = {
  featured_companies: FeaturedCompany[];
};

export function fetchFeaturedCompanies(): Promise<FeaturedCompaniesData> {
  return client
    .get('/api/v1/featured_companies')
    .then((response) => response.data as FeaturedCompaniesData)
    .catch((error) => {
      console.error('[FeaturedCompanies] Failed to fetch:', error);
      // エラー時は空配列を返す
      return { featured_companies: [] };
    });
}
